/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './paramedic-referral-charge.reducer';

export const ParamedicReferralCharge = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const paramedicReferralChargeList = useAppSelector(state => state.paramedicReferralCharge.entities);
  const loading = useAppSelector(state => state.paramedicReferralCharge.loading);
  const totalItems = useAppSelector(state => state.paramedicReferralCharge.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="paramedic-referral-charge-heading" data-cy="ParamedicReferralChargeHeading">
        <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.home.title">Paramedic Referral Charges</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/paramedic-referral-charge/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.home.createLabel">
              Create new Paramedic Referral Charge
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.paramedicReferralCharge.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {paramedicReferralChargeList && paramedicReferralChargeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('charge')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.charge">Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('charge')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('referralChargeType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.referralChargeType">Referral Charge Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralChargeType')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('addedByID')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.addedByID">Added By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByID')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th className="hand" onClick={sort('emergencyHike')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.emergencyHike">Emergency Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergencyHike')} />
                </th>
                <th className="hand" onClick={sort('hishRiskHike')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hishRiskHike">Hish Risk Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hishRiskHike')} />
                </th>
                <th className="hand" onClick={sort('emergencyHikeType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.emergencyHikeType">Emergency Hike Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergencyHikeType')} />
                </th>
                <th className="hand" onClick={sort('hishRiskHikeType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hishRiskHikeType">Hish Risk Hike Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hishRiskHikeType')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.doctor">Doctor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.paramedic">Paramedic</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {paramedicReferralChargeList.map((paramedicReferralCharge, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/paramedic-referral-charge/${paramedicReferralCharge.id}`} color="link" size="sm">
                      {paramedicReferralCharge.id}
                    </Button>
                  </td>
                  <td>{paramedicReferralCharge.charge}</td>
                  <td>{paramedicReferralCharge.active ? 'true' : 'false'}</td>
                  <td>{paramedicReferralCharge.cursor}</td>
                  <td>{paramedicReferralCharge.microSec}</td>
                  <td>{paramedicReferralCharge.lastUpdated}</td>
                  <td>{paramedicReferralCharge.timestampEntry}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ReferralChargeType.${paramedicReferralCharge.referralChargeType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${paramedicReferralCharge.addedByType}`} />
                  </td>
                  <td>{paramedicReferralCharge.addedByID}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${paramedicReferralCharge.modifiedByType}`} />
                  </td>
                  <td>{paramedicReferralCharge.modifiedByID}</td>
                  <td>{paramedicReferralCharge.emergencyHike}</td>
                  <td>{paramedicReferralCharge.hishRiskHike}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.HikeType.${paramedicReferralCharge.emergencyHikeType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.HikeType.${paramedicReferralCharge.hishRiskHikeType}`} />
                  </td>
                  <td>{paramedicReferralCharge.startDate}</td>
                  <td>{paramedicReferralCharge.endDate}</td>
                  <td>{paramedicReferralCharge.suspended ? 'true' : 'false'}</td>
                  <td>{paramedicReferralCharge.draft ? 'true' : 'false'}</td>
                  <td>
                    {paramedicReferralCharge.doctor ? (
                      <Link to={`/doctor/${paramedicReferralCharge.doctor.id}`}>{paramedicReferralCharge.doctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralCharge.hospital ? (
                      <Link to={`/hospital/${paramedicReferralCharge.hospital.id}`}>{paramedicReferralCharge.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralCharge.scheme ? (
                      <Link to={`/payment-scheme/${paramedicReferralCharge.scheme.id}`}>{paramedicReferralCharge.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralCharge.procedure ? (
                      <Link to={`/hospital-procedure/${paramedicReferralCharge.procedure.id}`}>{paramedicReferralCharge.procedure.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralCharge.paramedic ? (
                      <Link to={`/paramedic/${paramedicReferralCharge.paramedic.id}`}>{paramedicReferralCharge.paramedic.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/paramedic-referral-charge/${paramedicReferralCharge.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/paramedic-referral-charge/${paramedicReferralCharge.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/paramedic-referral-charge/${paramedicReferralCharge.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralCharge.home.notFound">No Paramedic Referral Charges found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={paramedicReferralChargeList && paramedicReferralChargeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ParamedicReferralCharge;
